module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "serviceSku"
    }
  }, [_c('div', {
    staticClass: "faultGroup container"
  }, [_c('ul', {
    staticClass: "clearfix"
  }, [_vm._l((_vm.GroupLists), function(item, index) {
    return _c('li', {
      key: index,
      staticClass: "GroupListPart listPart"
    }, [_c('span', {
      staticClass: "exitBtn",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.exitGroup(item)
        }
      }
    }, [_vm._v("编辑")]), _vm._v(" "), _c('em', {
      class: {
        disabledColor: item.state !== 1,
        disabledColor2: item.onlineStatus !== 1
      }
    }, [_vm._v(_vm._s(item.serveName))])])
  }), _vm._v(" "), _c('li', {
    staticClass: "addContent",
    on: {
      "click": function($event) {
        return _vm.newGroup()
      }
    }
  }, [_c('i', {
    staticClass: "el-icon-plus"
  })])], 2), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.textMenu[_vm.dialogMenuStatus],
      "visible": _vm.dislogGroup,
      "close-on-click-modal": false,
      "width": "600px"
    },
    on: {
      "update:visible": function($event) {
        _vm.dislogGroup = $event
      },
      "close": function($event) {
        return _vm.emptyDialog('GroupForm')
      }
    }
  }, [_c('el-form', {
    ref: "GroupForm",
    attrs: {
      "model": _vm.GroupForm,
      "label-width": "100px",
      "label-position": _vm.labelPosition,
      "rules": _vm.GroupFormRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "服务SKU：",
      "prop": "serveName"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.GroupForm.serveName),
      callback: function($$v) {
        _vm.$set(_vm.GroupForm, "serveName", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "GroupForm.serveName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "金额：",
      "prop": "serveMoney"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入金额",
      "type": "number"
    },
    model: {
      value: (_vm.GroupForm.serveMoney),
      callback: function($$v) {
        _vm.$set(_vm.GroupForm, "serveMoney", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "GroupForm.serveMoney"
    }
  }, [_c('template', {
    slot: "append"
  }, [_vm._v(".00")])], 2)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "排序：",
      "prop": "sort"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入排序"
    },
    model: {
      value: (_vm.GroupForm.sort),
      callback: function($$v) {
        _vm.$set(_vm.GroupForm, "sort", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "GroupForm.sort"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "启用状态",
      "prop": "state"
    }
  }, [_c('el-switch', {
    attrs: {
      "active-value": 1,
      "inactive-value": -1
    },
    model: {
      value: (_vm.GroupForm.state),
      callback: function($$v) {
        _vm.$set(_vm.GroupForm, "state", $$v)
      },
      expression: "GroupForm.state"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "上线状态",
      "prop": "onlineStatus"
    }
  }, [_c('el-switch', {
    attrs: {
      "active-value": 1,
      "inactive-value": -1
    },
    model: {
      value: (_vm.GroupForm.onlineStatus),
      callback: function($$v) {
        _vm.$set(_vm.GroupForm, "onlineStatus", $$v)
      },
      expression: "GroupForm.onlineStatus"
    }
  })], 1)], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [(_vm.dialogMenuStatus !== 'update') ? _c('el-button', {
    attrs: {
      "type": "success"
    },
    on: {
      "click": function($event) {
        return _vm.addEventFormSubmitBtn('GroupForm')
      }
    }
  }, [_vm._v("添加")]) : _c('el-button', {
    attrs: {
      "type": "success"
    },
    on: {
      "click": function($event) {
        return _vm.saveEventFormSubmitBtn('GroupForm')
      }
    }
  }, [_vm._v("保存")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        return _vm.emptyDialog('GroupForm')
      }
    }
  }, [_vm._v("取 消")])], 1)], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// /opt/devenv/allscs-jhh/repair-ui/~/vue-loader/lib/template-compiler?{"id":"data-v-5521e829","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!/opt/devenv/allscs-jhh/repair-ui/~/vue-loader/lib/selector.js?type=template&index=0!./src/views/basicSetting/serviceSku.vue
// module id = 1665
// module chunks = 0